export interface ComicPage {
  imageUrl: string;
  pageNumber: number;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverUrl: string;
  category: string;
  categorySlug: string;
  description: string;
  status: string;
  updateDate: string;
  views: number;
  rating: number;
  tags: string[];
  pages: ComicPage[];
  slug: string;
}

export interface ComicCategory {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const comicCategories: ComicCategory[] = [
  { name: '热血', slug: 'rexue', icon: 'ri-fire-line', count: 128 },
  { name: '恋爱', slug: 'lianai', icon: 'ri-heart-line', count: 95 },
  { name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', count: 87 },
  { name: '奇幻', slug: 'qihuan', icon: 'ri-magic-line', count: 76 },
  { name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line', count: 64 },
  { name: '日常', slug: 'richang', icon: 'ri-sun-line', count: 72 },
  { name: '冒险', slug: 'maoxian', icon: 'ri-compass-3-line', count: 83 },
  { name: '科幻', slug: 'kehuan', icon: 'ri-rocket-line', count: 56 },
];

export const allComics: Comic[] = [
  {
    id: '1',
    title: '龙族传说',
    author: '墨染星辰',
    coverUrl: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20dragon%20warrior%20epic%20fantasy%20warm%20orange%20tones%20dynamic%20action%20pose%20martial%20arts%20anime%20style%20illustration%20with%20clean%20white%20background%20professional%20manga%20cover%20design&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    description: '在远古时代，龙族与人族共存于广袤的大陆之上。少年龙辰意外觉醒了龙族血脉，从此踏上了一条充满挑战与奇遇的修炼之路。他必须面对强大的敌人，揭开自己的身世之谜，最终成为传说中的龙族之王。',
    status: '连载中',
    updateDate: '2026-08-04',
    views: 1285600,
    rating: 9.6,
    tags: ['热血', '战斗', '修炼', '龙族'],
    slug: 'longzu-chuanshuo',
    pages: [
      { pageNumber: 1, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20page%20dragon%20warrior%20in%20ancient%20temple%20epic%20atmosphere%20warm%20lighting%20detailed%20ink%20style%20manga%20art%20with%20speech%20bubbles%20clean%20illustration&width=800&height=1200&seq=comic-page-lz-01&orientation=portrait' },
      { pageNumber: 2, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20page%20young%20hero%20discovering%20hidden%20power%20glowing%20dragon%20aura%20inside%20cave%20warm%20golden%20light%20ink%20style%20manga%20art%20speech%20bubbles%20clean%20illustration&width=800&height=1200&seq=comic-page-lz-02&orientation=portrait' },
      { pageNumber: 3, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20page%20epic%20battle%20scene%20dragon%20warrior%20fighting%20monster%20dynamic%20action%20lines%20warm%20explosive%20effects%20ink%20style%20manga%20art%20speech%20bubbles%20clean%20illustration&width=800&height=1200&seq=comic-page-lz-03&orientation=portrait' },
      { pageNumber: 4, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comic%20page%20ancient%20Chinese%20village%20scene%20dragon%20warrior%20meeting%20elder%20warm%20sunset%20lighting%20detailed%20ink%20style%20manga%20art%20speech%20bubbles%20clean%20illustration&width=800&height=1200&seq=comic-page-lz-04&orientation=portrait' },
    ],
  },
  {
    id: '2',
    title: '星光下的约定',
    author: '月下樱花',
    coverUrl: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20manhua%20cover%20art%20couple%20under%20starry%20night%20sky%20school%20uniform%20sweet%20atmosphere%20warm%20pink%20tones%20anime%20style%20illustration%20clean%20white%20background%20professional%20manga%20cover&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '恋爱',
    categorySlug: 'lianai',
    description: '高中二年级的林小星在某个星光璀璨的夜晚，与转校生苏月许下了一个关于未来的约定。纯真的校园恋情、青春的烦恼与成长，两个年轻人如何在彼此的支持下追逐梦想？',
    status: '已完结',
    updateDate: '2026-07-28',
    views: 985200,
    rating: 9.3,
    tags: ['恋爱', '校园', '青春', '治愈'],
    slug: 'xingguang-xiade-yueding',
    pages: [
      { pageNumber: 1, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20manhua%20comic%20page%20girl%20and%20boy%20meeting%20under%20cherry%20blossom%20tree%20school%20campus%20warm%20spring%20lighting%20soft%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-xg-01&orientation=portrait' },
      { pageNumber: 2, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20manhua%20comic%20page%20couple%20talking%20on%20rooftop%20at%20sunset%20warm%20golden%20light%20soft%20atmosphere%20ink%20style%20manga%20art%20speech%20bubbles%20clean%20illustration&width=800&height=1200&seq=comic-page-xg-02&orientation=portrait' },
      { pageNumber: 3, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20manhua%20comic%20page%20girl%20confessing%20feelings%20under%20starry%20night%20sky%20romantic%20atmosphere%20warm%20gentle%20lighting%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-xg-03&orientation=portrait' },
    ],
  },
  {
    id: '3',
    title: '废柴逆袭记',
    author: '笑天居士',
    coverUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20manhua%20cover%20art%20funny%20underdog%20character%20making%20silly%20face%20bright%20colorful%20warm%20yellow%20tones%20anime%20style%20illustration%20clean%20white%20background%20professional%20manga%20cover&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    description: '王小二是一个彻头彻尾的废柴，每天都在混吃等死。直到有一天，他意外获得了一本神奇的秘籍，从此开始了啼笑皆非的逆袭之路。修炼、打怪、泡妞，搞笑不断！',
    status: '连载中',
    updateDate: '2026-08-03',
    views: 756800,
    rating: 8.9,
    tags: ['搞笑', '修炼', '逆袭', '轻松'],
    slug: 'feichai-nixiji',
    pages: [
      { pageNumber: 1, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20manhua%20comic%20page%20lazy%20guy%20sleeping%20in%20messy%20room%20suddenly%20finding%20magic%20book%20funny%20expression%20warm%20bright%20lighting%20ink%20style%20manga%20art%20speech%20bubbles&width=800&height=1200&seq=comic-page-fc-01&orientation=portrait' },
      { pageNumber: 2, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20manhua%20comic%20page%20funny%20character%20trying%20martial%20arts%20move%20falling%20down%20comically%20warm%20bright%20lighting%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-fc-02&orientation=portrait' },
    ],
  },
  {
    id: '4',
    title: '异界魔法学院',
    author: '幻影之翼',
    coverUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20cover%20art%20magic%20school%20students%20casting%20spells%20mystical%20atmosphere%20warm%20orange%20gold%20tones%20anime%20style%20illustration%20clean%20white%20background%20professional%20manga%20cover&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '奇幻',
    categorySlug: 'qihuan',
    description: '平凡的少年陆云在一次意外中被传送到了异世界的魔法学院。在这里，他发现自己拥有罕见的全系魔法天赋。与来自不同世界的同学们一起，他将揭开魔法学院背后的惊天秘密。',
    status: '连载中',
    updateDate: '2026-08-02',
    views: 1123400,
    rating: 9.4,
    tags: ['奇幻', '魔法', '学院', '冒险'],
    slug: 'yijie-mofa-xueyuan',
    pages: [
      { pageNumber: 1, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20comic%20page%20magic%20academy%20grand%20hall%20students%20in%20robes%20floating%20crystals%20warm%20mystical%20lighting%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-yj-01&orientation=portrait' },
      { pageNumber: 2, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20comic%20page%20boy%20discovering%20magic%20power%20glowing%20hands%20classroom%20setting%20warm%20golden%20light%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-yj-02&orientation=portrait' },
    ],
  },
  {
    id: '5',
    title: '暗夜追踪者',
    author: '黑夜行者',
    coverUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20manhua%20cover%20art%20detective%20in%20trench%20coat%20dark%20alley%20mysterious%20atmosphere%20warm%20amber%20streetlight%20tones%20anime%20style%20illustration%20clean%20white%20background%20professional%20manga%20cover&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '悬疑',
    categorySlug: 'xuanyi',
    description: '城市中接连发生离奇案件，私家侦探林夜被卷入了一系列超乎想象的事件中。随着调查的深入，他发现这些案件背后隐藏着一个庞大的神秘组织。真相究竟是什么？',
    status: '连载中',
    updateDate: '2026-08-01',
    views: 645300,
    rating: 9.1,
    tags: ['悬疑', '侦探', '都市', '推理'],
    slug: 'anye-zhuizongzhe',
    pages: [
      { pageNumber: 1, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20manhua%20comic%20page%20detective%20investigating%20crime%20scene%20dark%20rainy%20night%20warm%20streetlamp%20moody%20atmosphere%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-ay-01&orientation=portrait' },
      { pageNumber: 2, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20manhua%20comic%20page%20detective%20finding%20clue%20in%20old%20library%20dusty%20books%20warm%20dim%20lighting%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-ay-02&orientation=portrait' },
    ],
  },
  {
    id: '6',
    title: '喵星人的日常',
    author: '猫薄荷',
    coverUrl: 'https://readdy.ai/api/search-image?query=Chinese%20slice%20of%20life%20manhua%20cover%20art%20cute%20cats%20playing%20in%20cozy%20room%20warm%20sunlight%20gentle%20atmosphere%20anime%20style%20illustration%20clean%20white%20background%20professional%20manga%20cover&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '日常',
    categorySlug: 'richang',
    description: '三只性格迥异的猫咪和它们的主人之间的温馨日常。高冷的波斯猫小白、调皮的橘猫胖虎、胆小的英短灰灰，每一天都充满了欢笑与温暖。',
    status: '连载中',
    updateDate: '2026-08-04',
    views: 523100,
    rating: 9.5,
    tags: ['日常', '猫咪', '温馨', '治愈'],
    slug: 'miaoxingren-de-richang',
    pages: [
      { pageNumber: 1, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20slice%20of%20life%20manhua%20comic%20page%20cute%20cats%20sleeping%20on%20sofa%20cozy%20living%20room%20warm%20sunlight%20gentle%20atmosphere%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-mx-01&orientation=portrait' },
      { pageNumber: 2, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20slice%20of%20life%20manhua%20comic%20page%20girl%20feeding%20three%20cats%20in%20kitchen%20cute%20scene%20warm%20morning%20light%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-mx-02&orientation=portrait' },
    ],
  },
  {
    id: '7',
    title: '海贼王之新时代',
    author: '航海家阿飞',
    coverUrl: 'https://readdy.ai/api/search-image?query=Chinese%20adventure%20manhua%20cover%20art%20pirate%20crew%20on%20ship%20sailing%20ocean%20epic%20sunset%20warm%20golden%20tones%20anime%20style%20illustration%20clean%20white%20background%20professional%20manga%20cover&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '冒险',
    categorySlug: 'maoxian',
    description: '在大航海时代落幕后的新纪元，年轻的航海家路飞亚继承先辈的意志，组建了自己的海贼团，向着传说中的「最终之海」出发。未知的岛屿、强大的敌人、珍贵的友情，冒险永无止境！',
    status: '连载中',
    updateDate: '2026-08-03',
    views: 1567800,
    rating: 9.7,
    tags: ['冒险', '海贼', '热血', '友情'],
    slug: 'haizeiwang-xinshidai',
    pages: [
      { pageNumber: 1, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20adventure%20manhua%20comic%20page%20pirate%20ship%20sailing%20into%20sunset%20crew%20cheering%20epic%20warm%20atmosphere%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-hz-01&orientation=portrait' },
      { pageNumber: 2, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20adventure%20manhua%20comic%20page%20pirate%20crew%20discovering%20mysterious%20island%20tropical%20scenery%20warm%20bright%20lighting%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-hz-02&orientation=portrait' },
    ],
  },
  {
    id: '8',
    title: '星际穿越者',
    author: '星河作家',
    coverUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci%20fi%20manhua%20cover%20art%20astronaut%20floating%20in%20space%20with%20galaxy%20background%20futuristic%20spacesuit%20warm%20cosmic%20tones%20anime%20style%20illustration%20clean%20white%20background%20professional%20manga%20cover&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '科幻',
    categorySlug: 'kehuan',
    description: '公元3024年，人类已经掌握了星际穿越技术。年轻的航天员苏宇航在一次任务中穿越了虫洞，来到了一个完全陌生的星系。他必须在这片未知的星域中生存下去，寻找回到地球的方法。',
    status: '连载中',
    updateDate: '2026-07-30',
    views: 892400,
    rating: 9.2,
    tags: ['科幻', '星际', '冒险', '未来'],
    slug: 'xingji-chuanyuezhe',
    pages: [
      { pageNumber: 1, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci%20fi%20manhua%20comic%20page%20spaceship%20entering%20wormhole%20colorful%20cosmic%20energy%20warm%20futuristic%20lighting%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-xj-01&orientation=portrait' },
      { pageNumber: 2, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci%20fi%20manhua%20comic%20page%20astronaut%20discovering%20alien%20planet%20strange%20landscape%20warm%20orange%20sky%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-xj-02&orientation=portrait' },
    ],
  },
  {
    id: '9',
    title: '剑道无双',
    author: '剑心问道',
    coverUrl: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20cover%20art%20swordsman%20in%20white%20robe%20holding%20sword%20cherry%20blossom%20petals%20warm%20elegant%20tones%20anime%20style%20illustration%20clean%20white%20background%20professional%20manga%20cover&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    description: '在剑道为尊的世界里，少年剑晨凭借一把残破的铁剑，从最底层的剑徒开始，一步步攀登剑道的巅峰。以剑证道，以心御剑，他要成为这个时代最强的剑道宗师！',
    status: '连载中',
    updateDate: '2026-08-04',
    views: 1023400,
    rating: 9.5,
    tags: ['热血', '剑道', '修炼', '武侠'],
    slug: 'jiandao-wushuang',
    pages: [
      { pageNumber: 1, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20comic%20page%20young%20swordsman%20training%20in%20bamboo%20forest%20morning%20mist%20warm%20light%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-jd-01&orientation=portrait' },
    ],
  },
  {
    id: '10',
    title: '甜蜜陷阱',
    author: '糖果小姐',
    coverUrl: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20comedy%20manhua%20cover%20art%20girl%20and%20boy%20blushing%20at%20cafe%20sweet%20atmosphere%20warm%20pink%20cream%20tones%20anime%20style%20illustration%20clean%20white%20background%20professional%20manga%20cover&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '恋爱',
    categorySlug: 'lianai',
    description: '甜品师苏糖糖开了一家小小的甜品店，某天一位神秘帅哥天天光顾，每次都点同一款甜品。两人之间因甜品而结缘，一段甜蜜又爆笑的恋爱故事就此展开。',
    status: '连载中',
    updateDate: '2026-08-02',
    views: 678900,
    rating: 9.0,
    tags: ['恋爱', '美食', '甜宠', '都市'],
    slug: 'tianmi-xianjing',
    pages: [
      { pageNumber: 1, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20comedy%20manhua%20comic%20page%20girl%20baking%20in%20cute%20dessert%20shop%20handsome%20guy%20entering%20warm%20cozy%20lighting%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-tm-01&orientation=portrait' },
    ],
  },
  {
    id: '11',
    title: '全服第一搞笑担当',
    author: '键盘侠老张',
    coverUrl: 'https://readdy.ai/api/search-image?query=Chinese%20gaming%20comedy%20manhua%20cover%20art%20gamer%20screaming%20at%20computer%20screen%20funny%20exaggerated%20expression%20warm%20bright%20colors%20anime%20style%20illustration%20clean%20white%20background%20professional%20manga%20cover&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    description: '游戏宅男李非凡在热门网游中意外成为了全服第一，但原因不是他多厉害，而是他太搞笑了！每次打副本都能整出让人笑到肚子疼的操作，全服玩家都爱看他直播出糗。',
    status: '连载中',
    updateDate: '2026-08-01',
    views: 445600,
    rating: 8.7,
    tags: ['搞笑', '游戏', '日常', '轻松'],
    slug: 'quanfu-diyi-gaoxiao',
    pages: [
      { pageNumber: 1, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20gaming%20comedy%20manhua%20comic%20page%20gamer%20making%20funny%20face%20at%20computer%20messy%20room%20warm%20bright%20lighting%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-qf-01&orientation=portrait' },
    ],
  },
  {
    id: '12',
    title: '精灵契约',
    author: '森林之歌',
    coverUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20cover%20art%20elf%20girl%20with%20magical%20creatures%20in%20enchanted%20forest%20warm%20emerald%20gold%20tones%20anime%20style%20illustration%20clean%20white%20background%20professional%20manga%20cover&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: '奇幻',
    categorySlug: 'qihuan',
    description: '少女艾琳天生具有与精灵沟通的能力，但在人类世界这被视为异端。当她被驱逐出村庄后，在森林深处发现了精灵王国的存在，一场关于守护与勇气的奇幻冒险就此开始。',
    status: '已完结',
    updateDate: '2026-06-15',
    views: 567800,
    rating: 9.3,
    tags: ['奇幻', '精灵', '冒险', '治愈'],
    slug: 'jingling-qiyue',
    pages: [
      { pageNumber: 1, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20comic%20page%20girl%20talking%20to%20tiny%20glowing%20fairy%20in%20magical%20forest%20warm%20sunlight%20through%20trees%20ink%20style%20manga%20art%20speech%20bubbles%20clean&width=800&height=1200&seq=comic-page-jl-01&orientation=portrait' },
    ],
  },
];

export const featuredComics = allComics.filter(c => c.rating >= 9.3);

export const latestComics = [...allComics].sort((a, b) =>
  new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
);

export const hotComics = [...allComics].sort((a, b) => b.views - a.views);

export function getComicsByCategory(slug: string): Comic[] {
  return allComics.filter(c => c.categorySlug === slug);
}

export function getComicBySlug(slug: string): Comic | undefined {
  return allComics.find(c => c.slug === slug);
}

export function getCategoryBySlug(slug: string): ComicCategory | undefined {
  return comicCategories.find(c => c.slug === slug);
}